import React from "react"
import PropTypes from "prop-types"
import "app/static/stylus/QuorumIframe.styl"

// selectors
export const constructHtml = ({ id, htmlContent }) => {
    // since this content is being rendered inside of a sandboxed iframe, we need to manually
    // apply the highlight css inside of the iframe
    const head = (`
<head>
<meta charset="utf-8">
<style>
.highlighted, mark {
    background-color: #503ABD;
    color: #fff;
    font-weight: 900;
    font-size: 1.1em;
    padding: 2px 4px;
}
</style>
</head>
`)
    const html = [`data:text/html,${encodeURIComponent(head)}${encodeURIComponent(htmlContent)}`]
    // postMessage is unsupported in IE8/9, only partially supported in IE10 and unsupported in Edge 11 and lower
    // Given the above, we have a separate iframe onLoad fallback which is still able to
    // set the height since older browsers do not enforce
    // cross-domain "Blocked a frame with origin" checks
    if (window.parent.postMessage) {
        html.push(
            `
            <script>
            window.onload = function(event) {
                window.parent.postMessage(
                    {
                        height: document.body.scrollHeight,
                        id: "${id}-iframe",
                        origin: "quorum-iframe",
                    },
                    "${window.location.origin}"
                );
            };
            </script>
            `
        )
    }

    return html.join("\n")
}

// component
export const QuorumIframe = props => (
    <iframe
        className="quorum-iframe"
        id={`${props.id}-iframe`}
        src={constructHtml({
            id: props.id,
            htmlContent: props.htmlContent,
        })}
        onLoad={(event) => {
            // if the browser does not enforce a cross-origin policy,
            // then just access the height directly instead
            // (this is particularly important in the case where window.postMessage does not exist)
            try {
                const { target } = event
                const contentDocument = (
                    target.contentDocument ||
                    // Earlier versions of IE or IE8+ where !DOCTYPE is not specified
                    target.contentWindow.document
                )
                if (contentDocument) {
                    target.style.height = `${contentDocument.body.scrollHeight}px`
                }
            } catch (error) {
                const expectedError = (
                    `Blocked a frame with origin "${window.location.origin}" ` +
                    `from accessing a cross-origin frame.`
                )
                if (error.message !== expectedError) {
                    // not supported in Edge <12 nor IE <8
                    if (console.error) {
                        console.error(
                            `An error (${error.message}) ocurred while trying to check to see ` +
                            "if the inner iframe is accessible or not depending " +
                            "on the browser cross-origin policy"
                        )
                    }
                }
            }
        }}
        title={`${props.id}-iframe`}
    />
)

export default QuorumIframe

QuorumIframe.propTypes = {
    htmlContent: PropTypes.string,
    id: PropTypes.number,
}
